<form [formGroup]="formGroup">
  <label
    class="standalone-searchbox mb-3"
    [ngClass]="{
      'u-border-error': formGroup?.invalid && formGroup?.touched,
    }">
    <input
      #searchInput
      [placeholder]="
        'flu.wholesaler-pharmacy.popup.name-search-placeholder' | cxTranslate
      "
      [formControlName]="'pharmacyName'" />
    <button class="search-icon">
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </button>
  </label>
  <label
    class="standalone-searchbox mb-3"
    for="city"
    [ngClass]="{
      'u-border-error': formGroup?.invalid && formGroup?.touched,
    }">
    <input
      #searchInput
      [placeholder]="
        'flu.wholesaler-pharmacy.popup.city-search-placeholder' | cxTranslate
      "
      [formControlName]="'city'" />
    <button class="search-icon">
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </button>
  </label>
  <cx-form-errors
    class="text-danger"
    *ngIf="formGroup?.invalid && formGroup?.touched">
    <p class="mb-3">
      {{ 'flu.wholesaler-pharmacy.popup.form-error' | cxTranslate }}
    </p>
  </cx-form-errors>
  <button (click)="submit()" class="w-100 c-button c-button--secondary">
    {{ 'flu.wholesaler-pharmacy.popup.search' | cxTranslate }}
  </button>
</form>
